export let ConversationActionType;

(function (ConversationActionType) {
  ConversationActionType["TrackedShippment"] = "tracked_shipping_instructions";
  ConversationActionType["UntrackedShipment"] = "untracked_shipping_instructions";
  ConversationActionType["CustomShipment"] = "custom_shipping_instructions";
  ConversationActionType["ConfirmPackageSize"] = "confirm_package_size";
  ConversationActionType["ReuploadItem"] = "reupload";
  ConversationActionType["ResolveComplaint"] = "resolve_complaint";
  ConversationActionType["ViewComplaint"] = "view_complaint";
  ConversationActionType["DownloadShippingLabel"] = "download_shipping_label";
  ConversationActionType["CancellationConfirm"] = "cancellation_confirm";
  ConversationActionType["CancellationDecline"] = "cancellation_decline";
  ConversationActionType["TrackShipment"] = "track_shipment";
  ConversationActionType["MarkAsDelivered"] = "mark_as_delivered";
  ConversationActionType["MarkAsShipped"] = "mark_as_shipped";
  ConversationActionType["GetShippingLabel"] = "get_shipping_label";
  ConversationActionType["GoToWallet"] = "goto_wallet";
  ConversationActionType["CompleteTransaction"] = "all_is_good";
  ConversationActionType["ReportProblem"] = "i_have_issues";
  ConversationActionType["LeaveFeedback"] = "leave_feedback";
  ConversationActionType["UpdateBundle"] = "update_bundle";
  ConversationActionType["WeHaveMet"] = "we_have_met";
  ConversationActionType["ClaimCompensation"] = "claim_compensation";
  ConversationActionType["RequestReturn"] = "request_to_return";
  ConversationActionType["GetReturnShippingLabel"] = "get_return_shipping_label";
  ConversationActionType["ConfirmComplaintResolved"] = "confirm_complaint_resolved";
  ConversationActionType["RefuseComplaintResolved"] = "refuse_complaint_resolved";
  ConversationActionType["ViewDeliveryInstructions"] = "view_delivery_instructions";
  ConversationActionType["OpenQrCode"] = "open_qr_code";
  ConversationActionType["RefundProgress"] = "refund_progress";
  ConversationActionType["NeedHelpSelectChatbotIssue"] = "need_help_select_chatbot_issue";
  ConversationActionType["SelectChatbotIssue"] = "select_chatbot_issue";
  ConversationActionType["ConfirmComplaintResolvedAndLeaveFeedback"] = "confirm_complaint_resolved_and_leave_feedback";
  ConversationActionType["LeaveComplaintFeedback"] = "leave_complaint_feedback";
  ConversationActionType["PushUpFeedback"] = "push_up_feedback";
  ConversationActionType["ActivateBalance"] = "activate_balance";
  ConversationActionType["ReturnOrder"] = "return_order";
  ConversationActionType["MarkAsReturnedToSender"] = "complete_return_to_sender";
  ConversationActionType["GetReservationLink"] = "get_reservation_link";
  ConversationActionType["AppealTheDecision"] = "appeal_the_decision";
})(ConversationActionType || (ConversationActionType = {}));

export let ConversationInitiatorType;

(function (ConversationInitiatorType) {
  ConversationInitiatorType["Buy"] = "buy";
  ConversationInitiatorType["Bundle"] = "bundle";
  ConversationInitiatorType["Message"] = "message";
  ConversationInitiatorType["AskSeller"] = "ask_seller";
  ConversationInitiatorType["BuyerOffer"] = "buyer_offer";
  ConversationInitiatorType["MarkAsSold"] = "mark_as_sold";
  ConversationInitiatorType["Reservation"] = "reservation";
  ConversationInitiatorType["SystemMessage"] = "system_message";
  ConversationInitiatorType["BuyerEntersOfferForm"] = "buyer_enters_offer_form";
  ConversationInitiatorType["SellerEntersNotification"] = "seller_enters_notification";
})(ConversationInitiatorType || (ConversationInitiatorType = {}));

export let ConversationMessageType;

(function (ConversationMessageType) {
  ConversationMessageType["ActionMessage"] = "action_message";
  ConversationMessageType["StatusMessage"] = "status_message";
  ConversationMessageType["Message"] = "message";
  ConversationMessageType["PortalMessage"] = "portal_message";
  ConversationMessageType["OfferMessage"] = "offer_message";
  ConversationMessageType["OfferRequestMessage"] = "offer_request_message";
  ConversationMessageType["ReportSuggestion"] = "report_suggestion";
})(ConversationMessageType || (ConversationMessageType = {}));

export let ConversationMessageReactionType;

(function (ConversationMessageReactionType) {
  ConversationMessageReactionType["Heart"] = "heart";
})(ConversationMessageReactionType || (ConversationMessageReactionType = {}));

export let StatusStyle;

(function (StatusStyle) {
  StatusStyle["Gray"] = "gray_box";
  StatusStyle["Green"] = "green_box";
  StatusStyle["Red"] = "red_box";
  StatusStyle["Clear"] = "clear_box";
})(StatusStyle || (StatusStyle = {}));

export let StatusIcon;

(function (StatusIcon) {
  StatusIcon["Sale"] = "sale";
  StatusIcon["Shipment"] = "shipment";
  StatusIcon["Completion"] = "completion";
  StatusIcon["Failure"] = "failure";
})(StatusIcon || (StatusIcon = {}));

export let OfferRequestStatus;

(function (OfferRequestStatus) {
  OfferRequestStatus[OfferRequestStatus["Pending"] = 10] = "Pending";
  OfferRequestStatus[OfferRequestStatus["Accepted"] = 20] = "Accepted";
  OfferRequestStatus[OfferRequestStatus["Outdated"] = 30] = "Outdated";
})(OfferRequestStatus || (OfferRequestStatus = {}));

export let ConversationLinkActions;

(function (ConversationLinkActions) {
  ConversationLinkActions["ShipmentTrackingLink"] = "react-shipment-tracking-link";
  ConversationLinkActions["BuyerDetailsLink"] = "buyer-details-link";
  ConversationLinkActions["OfflineVerificationInfoLink"] = "react-offline-verification-info-link";
  ConversationLinkActions["DropOffPointMapLink"] = "react-drop-off-point-map-link";
})(ConversationLinkActions || (ConversationLinkActions = {}));

export let ComposerType;

(function (ComposerType) {
  ComposerType["StartConversation"] = "start_conversation";
  ComposerType["Reply"] = "reply";
})(ComposerType || (ComposerType = {}));

export let UserSide;

(function (UserSide) {
  UserSide["Seller"] = "seller";
  UserSide["Buyer"] = "buyer";
})(UserSide || (UserSide = {}));

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PER_PAGE = 20;
export const PER_PAGE_OPTIONS = [20, 50, 100];
export const DEFAULT_PER_PAGE_INDEX = PER_PAGE_OPTIONS.findIndex(option => option === DEFAULT_PER_PAGE);
export let GenerateLabelModal;

(function (GenerateLabelModal) {
  GenerateLabelModal["GetShippingLabelModal"] = "getShippingLabel";
  GenerateLabelModal["DropOffTypeSelectionModal"] = "dropOffTypeSelection";
  GenerateLabelModal["ConfirmationModal"] = "confirmation";
  GenerateLabelModal["AddressModal"] = "address";
  GenerateLabelModal["ShippingContactModal"] = "shippingContact";
  GenerateLabelModal["CourierPickUpDateSelectionModal"] = "courierPickUpDateSelection";
  GenerateLabelModal["DigitalLabelTypeSelectionModal"] = "digitalLabelTypeSelection";
  GenerateLabelModal["ReturnTheOrder"] = "returnTheOrder";
  GenerateLabelModal["ReturnCurrencyConversionModal"] = "returnCurrencyConversionModal";
  GenerateLabelModal["ShippingDiscountModal"] = "shippingDiscountModal";
  GenerateLabelModal["DropOffPointMapModal"] = "dropOffPointMapModal";
  GenerateLabelModal["None"] = "none";
})(GenerateLabelModal || (GenerateLabelModal = {}));

export let DigitalLabelAbTestVariant;

(function (DigitalLabelAbTestVariant) {
  DigitalLabelAbTestVariant["Disabled"] = "off";
})(DigitalLabelAbTestVariant || (DigitalLabelAbTestVariant = {}));

export let LabelType;

(function (LabelType) {
  LabelType[LabelType["LabelTypePdf"] = 1] = "LabelTypePdf";
  LabelType[LabelType["LabelTypeCode"] = 2] = "LabelTypeCode";
  LabelType[LabelType["LabelTypeQr"] = 3] = "LabelTypeQr";
})(LabelType || (LabelType = {}));

export let ShipmentLabelType;

(function (ShipmentLabelType) {
  ShipmentLabelType["LabelTypePdf"] = "pdf";
  ShipmentLabelType["LabelTypeQr"] = "qr";
  ShipmentLabelType["LabelTypeCode"] = "code";
  ShipmentLabelType["LabelTypeReservationLink"] = "reservation_link";
})(ShipmentLabelType || (ShipmentLabelType = {}));

export let ModeratedItemAvailabilityStatus;

(function (ModeratedItemAvailabilityStatus) {
  ModeratedItemAvailabilityStatus[ModeratedItemAvailabilityStatus["Visible"] = 0] = "Visible";
  ModeratedItemAvailabilityStatus[ModeratedItemAvailabilityStatus["Hidden"] = 1] = "Hidden";
  ModeratedItemAvailabilityStatus[ModeratedItemAvailabilityStatus["Deleted"] = 2] = "Deleted";
  ModeratedItemAvailabilityStatus[ModeratedItemAvailabilityStatus["Expired"] = 3] = "Expired";
})(ModeratedItemAvailabilityStatus || (ModeratedItemAvailabilityStatus = {}));